/*
 * @Author: 朱占伟
 * @LastEditors: 邱扬
 * @description: 用户相关
 * @Date: 2021-09-09 15:34:40
 * @LastEditTime: 2022-02-21 10:20:03
 */


import { post, } from 'utils/request';
import $api from "src/config/api.config"  


/**
 * @description: 设置prefer
 * @param {*}
 * @return {*}
 */
export const getUserPrefer = async(patams=null) => {
  try {
    const res = await post($api.GET_USER_PREFER, patams);
    if (res.code === 0) {
      return res.data
    }
    return null
  } catch (error) {
    return Promise.resolve(null)
  }
};


/**
 * @Date: 2021-09-09 15:35:38MINE_GET_INFO
 * @LastEditTime: 
 * @description: 获取个人信息
 * @param {*}
 * @return {*}
 */
export const getMineInfo = async(patams = null) => {
  try {
    const res = await post($api.MINE_GET_INFO, patams);
    if (res.code === 0) {
      return res.data
    }
    return null
  } catch (error) {
    return Promise.resolve(null)
  }
};

/**
 * @Date: 2021-09-09 15:41:57
 * @LastEditTime: 
 * @description: 获取用户状态
 * @param {*} patams
 * @return {*}
 */
export const getUserActiveOpt = async(patams = null) => {
  try {
    const res = await post($api.GET_USER_ACTIVE, patams);
    if (res && res.code === 0) {
      return res.data
    }
    return null
  } catch (error) {
    console.error('getUserActiveOpt',error)
    return Promise.resolve(null)
  }
};


/**
 * @Date: 2021-09-09 15:41:57
 * @LastEditTime: 
 * @description: 获取活动信息
 * @param {*} patams
 * @return {*}
 */
export const getReferralDetail = async(patams = null) => {
  try {
    const res = await post($api.MINE_REFERRAL_ACTIVITY, patams);
    if (res && res.code === 0) {
      return res.data
    }
    return null
  } catch (error) {
    console.error('getReferralDetail',error)
    return Promise.resolve(null)
  }
};


/**
 * @Date: 2021-09-09 15:41:57
 * @LastEditTime: 
 * @description: 重发邮箱
 * @param {*} patams
 * @return {*}
 */
export const reSendMail = async(patams = null) => {
  try {
    const res = await post($api.POST_USER_EMAIL, patams);
    return res
  } catch (error) {
    return Promise.resolve(null)
  }
};


/**
 * @Date: 2021-09-09 15:41:57
 * @LastEditTime: 
 * @description: 设置联系方式
 * @param {*} patams
 * @return {*}
 */
export const setContact = async(patams = null) => {
  try {
    const res = await post($api.POST_SET_CONTACT, patams);
    return res
  } catch (error) {
    console.error('setContact',error)
  }
}

//获取referral模块的链接数据
export const referralLink = async(patams = null) => {
  try {
    const res = await post($api.MINE_REFER_LINK, patams);
    return res.data
  } catch (error) {
    console.error('referralLink',error)
    return Promise.resolve(null)
  }
};

//获取referral模块的表格数据
export const referralTableData = async(patams = null) => {
  try {
    const res = await post($api.MINE_MYREFER_TABLE, patams);
    return res.data
  } catch (error) {
    console.error('referralTableData',error)
    return Promise.resolve(null)
  }
};

//获取referral模块的Log表格数据
export const referralTableLogData = async(patams = null) => {
  try {
    const res = await post($api.MINE__MY_LOG_DATA, patams);
    return res.data
  } catch (error) {
    console.error('referralTableLogData',error)
    return Promise.resolve(null)
  }
};

//获取transaction模块数据
export const transactionTableData = async(patams = null) => {
  try {
    const res = await post($api.MINE_TRANSACTIONS_DATA, patams);
    return res.data
  } catch (error) {
    console.error('transactionTableData',error)
    return Promise.resolve(null)
  }
};

//获取用户等级信息
export const userGradeInfo = async(patams = null) => {
  try {
    const res = await post($api.MINE_MEMBER_INFO, patams);
    return res.data
  } catch (error) {
    console.error('userGradeInfo',error)
    return Promise.resolve(null)
  }
};

//更新国家
export const updateRegion = async(patams = null) => {
  try {
    const res = await post($api.MINE_UPDATE_REGION, patams);
    return res.data
  } catch (error) {
    console.error('updateRegion',error)
    return Promise.resolve(null)
  }
};

//更新密码
export const updatePassword = async(patams = null) => {
  try {
    const res = await post($api.MINE_UPDATE_PASSWORD, patams);
    return res.data
  } catch (error) {
    console.error('updatePassword',error)
    return Promise.resolve(null)
  }
};

//获取关键字
export const getKeyword = async(patams = null) => {
  try {
    const res = await post($api.POST_LIST_WORDS, patams);
    return res.data
  } catch (error) {
    console.error('getKeyword',error)
    return Promise.resolve(null)
  }
};

//获取关键字
export const getKeywordForAddMore = async(params = null) => {
  try {
    const res = await post($api.POST_LIST_WORDS_AND_RANK, params);
    return res.data
  } catch (error) {
    console.error('getKeyword',error)
    return Promise.resolve(null)
  }
};

//获取词排名

export const getWordRank = async(patams = null) => {
  try {
    const res = await post($api.GET_WORD_RANK, patams);
    return res.data
  } catch (error) {
    console.error('getWordRank',error)
    return Promise.resolve(null)
  }
};

//add 关键词
export const addKeyword = async(patams = null) => {
  try {
    const res = await post($api.POST_ADD_KEYWORD, patams);
    return res.data
  } catch (error) {
    console.error('addKeyword',error)
    return Promise.resolve(null)
  }
};

//获取app列表
export const getAppList = async(patams = null) => {
  try {
    const res = await post($api.HOME_GET_LIST, patams);
    return res.data
  } catch (error) {
    console.error('getAppList',error)
    return Promise.resolve(null)
  }
};
//App收藏/置顶
export const setAppStar = async(patams = null) => {
  try {
    const res = await post($api.MINE_SET_STAR, patams);
    return res.data
  } catch (error) {
    console.error('setAppStar',error)
    return Promise.resolve(null)
  }
};
//App收藏/置顶
export const deleteAppItem = async(patams = null) => {
  try {
    const res = await post($api.MINE_DELETE_APP, patams);
    return res.data
  } catch (error) {
    console.error('deleteAppItem',error)
    return Promise.resolve(null)
  }
};


//删除关键字
export const deleteKeyword = async(patams = null) => {
  try {
    const res = await post($api.MINE_DELETE_KEYWORD, patams);
    return res.data
  } catch (error) {
    console.error('deleteKeyword',error)
    return Promise.resolve(null)
  }
};
//展示推荐关键字
export const showSuggestKeyword = async(patams = null) => {
  try {
    const res = await post($api.MINE_RECOMMENDDATION_KEYWORD, patams);
    return res.data
  } catch (error) {
    console.error('showSuggestKeyword',error)
    return Promise.resolve(null)
  }
};
//获取referral模块的链接数据
export const  hasUnread= async(patams = null) => {
  try {
    const res = await post($api.GET_HAS_UNREAD, patams);
    return res.data
  } catch (error) {
    return Promise.resolve(null)
  }
};

//获取消耗统计模块数据
export const  getConsumptionData= async(patams = null) => {
  try {
    const res = await post($api.GET_CONSUMPTION_DATA, patams);
    return res.data
  } catch (error) {
    return Promise.resolve(null)
  }
};

//订阅邮件
export const  postSubscribe= async(patams = null) => {
  try {
    const res = await post($api.POST_SUNSCRIBE, patams);
    return res.data
  } catch (error) {
    return Promise.resolve(null)
  }
};
//退订邮件
export const  postUnsubscribe= async(patams = null) => {
  try {
    const res = await post($api.POST_UNSUNSCRIBE, patams);
    return res.data
  } catch (error) {
    return Promise.resolve(null)
  }
};
//获取分销商level
export const  getResellerLevel= async(patams = null) => {
  try {
    const res = await post($api.GET_RESELLER_LEVEL, patams);
    return res.data
  } catch (error) {
    return Promise.resolve(null)
  }
};
//撤销reseller提交
export const  cancelResellerForm= async(patams = null) => {
  try {
    const res = await post($api.CANCEL_RESELLER_FORM, patams);
    return res.data
  } catch (error) {
    return Promise.resolve(null)
  }
};
//创建分销商申请
export const  createResellerForm= async(patams = null) => {
  try {
    const res = await post($api.CREATE_RESELLER_FORM, patams);
    return res
  } catch (error) {
    return Promise.resolve(null)
  }
};

//获取上一次申请信息
export const  getLastResellerForm= async(patams = null) => {
  try {
    const res = await post($api.GET_LAST_RESELLER_APPlication, patams);
    return res.data
  } catch (error) {
    return Promise.resolve(null)
  }
};

//获取申请状态
export const  getResellerState= async(patams = null) => {
  try {
    const res = await post($api.GET_RESELLER_STATE, patams);
    return res.data
  } catch (error) {
    return Promise.resolve(null)
  }
};

//前端埋点
export const  eventTrack= async(params = null) => {
  try {
    const res = await post($api.EVENT_TRACK, params);
    return res.data
  } catch (error) {
    return Promise.resolve(null)
  }
};